import React, { useCallback, useContext } from "react";
import { useLocation } from "react-router";
import Config from "../config.json";

import TextInput from "./inputs/TextInput";
import DateRangeInput from "./inputs/DateRangeInput";
import DropdownInput from "./inputs/DropdownInput";

import SearchContext from "../context/SearchContext";
  
function SideNav({ folderMetadata }) {
  const location = useLocation();
  const {searchAfterFilter, filters, updateFilterValue, clearSearch } = useContext(SearchContext);
  
  const folders = Config.storage.folders
    .filter((f) => f.hidden !== true)
    .sort((a, b) => a.name.localeCompare(b.name));

  const handleOnChange = useCallback((object, type, fieldname) => {
    updateFilterValue(object, type, fieldname);
  }, [updateFilterValue]);

  const handleOnChangeKeywords = useCallback((object) => {
    updateFilterValue(object, "keywords", "");
  }, [updateFilterValue]);

  const onFilterClick = useCallback(() => {
    searchAfterFilter(folders.find(f => f.routePath === location.pathname).name);
  }, [searchAfterFilter, folders, location.pathname]);

  const handleDateFilterEnter = useCallback(() => {
    onFilterClick();
  }, [onFilterClick]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter' && !e.target.classList.contains('datepicker-input')) {
      onFilterClick();
    }
  }, [onFilterClick]);

  const onClearClick = () => {
    let folder = folders.find(f => f.routePath === location.pathname).name;
    clearSearch(folder);
  }
  return (
    <aside className="col-xs-12 col-sm-12 col-md-4 col-lg-3 region-sidebar-left mt-3" onKeyDown={handleKeyDown}>
      <h2 className="sidebar-menu-header h5">
        Filters
      </h2>

      <nav id="sidebar-menu-new" aria-label="Side navigation listing folder links">
        <ul className="list-unstyled">
          {folders.map((folder, i) => (
            <li key={folder.name}>
              {location.pathname === folder.routePath && (
                <div className="mb-5 side-input-group">
                  <TextInput index={-1}
                    name="Keywords" 
                    fieldname="keywords"
                    onChange={handleOnChangeKeywords}
                    value={filters.keywords} />
                  {folder.metadata.filter(f => f.searchable === true).map((field, i) => {
                    switch(field.inputType) {
                      case "text":
                        return (
                          <TextInput key={i} 
                            index={i} 
                            name={field.name} 
                            fieldname={field.id} 
                            onChange={handleOnChange}
                            value={filters[field.id]} />
                        );
                      case "datetime":
                        return (
                          <DateRangeInput key={i} 
                            index={i} 
                            name={field.name} 
                            fieldname={field.id}
                            onChange={handleOnChange}
                            value={filters[field.id]}
                            onEnterPress={handleDateFilterEnter} />
                        );
                      case "dropdown":
                        return (
                          <DropdownInput key={i} 
                            index={i} 
                            name={field.name} 
                            fieldname={field.id} 
                            onChange={handleOnChange}
                            value={filters[field.id]}
                            dropdownValues={folderMetadata[folder.name]?.[field.id] ? 
                              Array.from(folderMetadata[folder.name][field.id]) : []} />
                        );
                      default:
                        return null;
                    }
                  })}
                  <div className="btn-container  d-flex justify-content-end">
                    <button className="btn btn-outline-primary mt-1 mb-1 mr-1" onClick={onClearClick}>Clear</button>
                    <button className="btn btn-primary mt-1 mb-1 ml-1" onClick={onFilterClick}>Filter</button>
                  </div>
                </div>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}

export default SideNav;